export const getRelativePaddingTop = (html) => {
  const rect = html.getBoundingClientRect();
  const paddingTop = parseInt(getComputedStyle(html).paddingTop, 10);
  return ((paddingTop * 100) / rect.height) * 0.01;
};

export const getRelativePaddingLeft = (html) => {
  const rect = html.getBoundingClientRect();
  const paddingLeft = parseInt(getComputedStyle(html).paddingLeft, 10);
  return ((paddingLeft * 100) / rect.width) * 0.01;
};
